import { useEffect, useState } from 'react';
import { useMatch } from 'react-router-dom';

import useCheckDiscountCodeQuery from 'api/queries/useCheckDiscountCodeQuery';
import { getSignupLocalStorage } from 'utils/signupUtils';

export default function useSignupNanoBanner(appliedPromo) {
    const [renderSignupNanoBanner, setRenderSignupNanoBanner] = useState(false);
    const isAcquisitionPDPRoute = !!useMatch('/:slug/p');
    const isSignupRoute = !!useMatch('/join/*');
    const isConfirmationRoute = !!useMatch('/join/confirmation');
    const signupLocalStorage = getSignupLocalStorage();
    const discountCode = signupLocalStorage?.discountCode;

    const { data: discountCodeData, isLoading: isDiscountsLoading } = useCheckDiscountCodeQuery({
        discountCode,
        extendedQueryKeys: appliedPromo,
    });

    useEffect(() => {
        setRenderSignupNanoBanner(
            (isAcquisitionPDPRoute || isSignupRoute) &&
                !isConfirmationRoute &&
                !isDiscountsLoading &&
                discountCodeData?.disc?.valid
        );
    }, [isSignupRoute, isConfirmationRoute, isDiscountsLoading]);

    return { renderSignupNanoBanner, discountCodeData };
}
